"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mercatino-conca": {
    "0b87ee84": [{
      "hkey": "779925fa",
      "slug": "mercatino-conca",
      "name": "Mercatino Conca",
      "primary": true,
      "skipSearch": false
    }],
    "ca-centirocco": [{
      "hkey": "779925fa",
      "slug": "mercatino-conca",
      "name": "Mercatino Conca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "943cad35": [{
      "hkey": "65d291ac",
      "slug": "monte-altavelio",
      "name": "Monte Altavelio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-altavellio": [{
      "hkey": "65d291ac",
      "slug": "monte-altavelio",
      "name": "Monte Altavelio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;